import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { Homepage } from 'src/app/Models/homepage';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-homepages',
  templateUrl: './homepages.component.html',
  styleUrls: ['./homepages.component.css']
})
export class HomepagesComponent implements OnInit {
  formTitle = "Manage Banners";
  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  dataList = [];
  loadingRecords = true;
  sortValue: string = "desc";
  sortKey: string = "id";
  searchText: string = "";
  filterQuery: string = "";
  isFilterApplied: string = "default";
   logtext:string = "";
   pageSize2=10

  columns: string[][] =[ ["BANNER1_TITLE","Banner Title 1"],["BANNER2_TITLE","Banner2  Title"],["BANNER3_TITLE","Banner3 Title"],["DESCRIPTION","Description"],["EVENT_LIST","Event List"]]

  //drawer Variables
  drawerVisible: boolean;
  drawerTitle: string;
  drawerData: Homepage = new Homepage();
  constructor(private api: ApiService,private message: NzNotificationService) { }
  ngOnInit() {
    this.search();

	this.logtext = 'OPENED - Homepages form KEYWORD[O - Homepages] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
  }
    // Basic Methods
    sort(sort: { key: string; value: string }): void {
      this.sortKey = sort.key;
      this.sortValue = sort.value;
      this.search(true);
  
    }
  search(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }
    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
	
	this.logtext = 'Filter Applied - Homepages form"+ sort +" "+this.sortKey +" KEYWORD [F - Homepages] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //     });

    } catch (error) {
      sort = "";
    }
    console.log("search text:" + this.searchText);
    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)
      console.log("likeQuery" + likeQuery);
    }

	this.logtext = 'Filter Applied - Homepages form "+ likeQuery +" KEYWORD [F - Homepages] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //     });

    this.api.getAllHomepages(this.pageIndex, this.pageSize, this.sortKey, sort, likeQuery).subscribe(data => {
      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.dataList = data['data'];
    }, err => {
      console.log(err);
    });
  }
  //Drawer Methods
  get closeCallback() {
    return this.drawerClose.bind(this);
  }
  add(): void {
    this.drawerTitle = "Create New Homepage";
    this.drawerData = new  Homepage();
    this.drawerVisible = true;

	this.logtext = 'ADD - Homepage form KEYWORD [A - Homepage] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //     });

  }
  edit(data:  Homepage): void {
    if (data.BANNER1_IMAGE_URL != "")
    data.BANNER1_IMAGE_URL = this.api.retriveimgUrl + "BannerImages/" + data.BANNER1_IMAGE_URL
  if (data.BANNER2_IMAGE_URL != "")
    data.BANNER2_IMAGE_URL = this.api.retriveimgUrl + "BannerImages/" + data.BANNER2_IMAGE_URL
    if (data.BANNER3_IMAGE_URL != "")
    data.BANNER3_IMAGE_URL = this.api.retriveimgUrl + "BannerImages/" + data.BANNER3_IMAGE_URL



    this.drawerTitle = "Update Home page Information";
    this.drawerData = Object.assign({}, data);
    this.drawerVisible = true;

	this.logtext = 'EDIT - Homepage form KEYWORD [E - Homepage] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });


  }
  drawerClose(): void {
    this.search();
    this.drawerVisible = false;
  }

  
  publish(): void {

    this.api.publish('masterDetails')
      .subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.message.success("Page Published Successfully", "");
          window.open("http://krishnakoyanapatsanstha.com/index.html", "_blank");
        }
        else {
          this.message.error("Failed to publish...", "");
        }
      });

  }


  preview(): void {

    this.api.preview('masterDetails')
      .subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.message.success("Page Published Successfully", "");
          window.open("http://krishnakoyanapatsanstha.com/preview/index.html", "_blank");
        }
        else {
          this.message.error("Failed to publish...", "");
        }
      });

  }
}